var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.task.threadRequiresUserAttention)?_c('el-tooltip',{attrs:{"content":'The candidate is waiting on ' + _vm.task.teamName + ' to respond',"open-delay":500}},[_c('span',{staticClass:"ml-8 material-icons-round align-items-center text-color-black-50 md-18"},[_vm._v(" mark_unread_chat_alt ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }